class VariantHandSlider extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const range = this.querySelector('[data-hand-slider-range]');
    if (!(range instanceof HTMLInputElement)) return;

    range.addEventListener('input', () => this.#select(Number(range.value)), {
      signal: this.#controller.signal,
    });
    this.addEventListener('click', (event) => event.stopPropagation(), { signal: this.#controller.signal });
    this.addEventListener('pointerdown', (event) => event.stopPropagation(), { signal: this.#controller.signal });

    this.#select(Number(range.value));
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #select(index) {
    const images = Array.from(this.querySelectorAll('.variant-hand-slider__image'));
    const range = this.querySelector('[data-hand-slider-range]');
    const counter = this.querySelector('[data-hand-slider-counter]');
    if (!(range instanceof HTMLInputElement) || images.length === 0) return;

    const selected = Math.max(0, Math.min(images.length - 1, index - 1));
    range.value = String(selected + 1);
    range.setAttribute('aria-valuenow', String(selected + 1));
    range.setAttribute('aria-valuetext', `Image ${selected + 1} of ${images.length}`);

    images.forEach((image, imageIndex) => {
      const active = imageIndex === selected;
      image.classList.toggle('is-active', active);
      image.setAttribute('aria-hidden', String(!active));
    });

    if (counter) counter.textContent = `${selected + 1} / ${images.length}`;
  }
}

if (!customElements.get('variant-hand-slider')) {
  customElements.define('variant-hand-slider', VariantHandSlider);
}